const ScreensInt = {
  'md': 768,
  'lg': 1024,
  'xl': 1440
}

const Screens = {
  'md': { 'min': `${ScreensInt.md}px` },
  'lg': { 'min': `${ScreensInt.lg}px` },
  'xl': { 'min': `${ScreensInt.xl}px` }
};

module.exports = { Screens, ScreensInt };
